import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Line } from 'vue-chartjs';
import moment from 'moment';
import get from 'lodash/get';
import set from 'lodash/set';
import merge from 'lodash/merge';
var CHART_BEGIN_ZERO = false;
var CHART_FILLED_AREA = true;
var defaultChartConfig = {
  drawBackground: CHART_FILLED_AREA,
  scales: {
    yAxes: [{
      ticks: _objectSpread({}, CHART_BEGIN_ZERO ? {
        suggestedMin: 0
      } : {}),
      gridLines: {
        display: true
      }
    }],
    xAxes: [{
      type: 'time',
      // do not use time-series, as it assumes equidistant spreading of the time-values
      // this does not work for "raw" data, as those come in at "random" time-intervals
      // https://www.chartjs.org/docs/latest/axes/cartesian/timeseries.html
      // distribution: 'series',
      time: {
        unit: 'hour'
      },
      ticks: {
        autoSkip: true
      },
      gridLines: {
        display: true
      }
    }]
  },
  legend: {
    display: true
  },
  tooltips: {
    mode: 'index',
    callbacks: {
      // display the whole range of the current item in the tooltip, as it is NOT a discrete point in time
      // https://digimondo.atlassian.net/browse/RD-6203
      // https://www.chartjs.org/docs/latest/configuration/tooltip.html#tooltip-callbacks
      // https://www.chartjs.org/docs/latest/configuration/tooltip.html#tooltip-item-context
      title: function title(tooltipItem, data) {
        var timeformat = 'YYYY-MM-DD HH:mm'; // get current index of data-label for the displayed span

        var currentIndex = tooltipItem[0].index; // if this is the latest item or there are raw-timestamps to be printed, just print it as-is without span
        // (Note: the items are reversed, to make sure that the latest values are displayed, so Index 0 === latest timestamp)

        var isRawData = get(data, "datasets[".concat(tooltipItem[0].datasetIndex, "].rawKey")) === 'rawData' && tooltipItem.length === 1;

        if (currentIndex === 0 || isRawData) {
          // last index is just printed as-is, or this is raw data
          return moment(data.labels[currentIndex]).format(timeformat);
        } // we cannot display just the 2 consecutive time-stamps from the labels, as there may be data missing in-between
        // null-data is filtered out, so if the interval is big enough (or the state-update-interval too low), there are gaps
        // so calculte the time-interval "manually"


        var timeSpanMs = get(data, "datasets[".concat(tooltipItem[0].datasetIndex, "].timeSpanMs"));
        var currentTimestamp = moment(data.labels[currentIndex]).format(timeformat);
        var nextTimestamp = moment(new Date(new Date(data.labels[currentIndex]) - -timeSpanMs).toISOString()).format(timeformat);
        return "".concat(currentTimestamp, " - ").concat(nextTimestamp);
      }
    }
  },
  responsive: true,
  maintainAspectRatio: false
};
export default {
  name: 'CoreChartHistoryStateLine',
  extends: Line,
  props: {
    chartData: {
      type: Object,
      default: function _default() {
        return {
          data: {}
        };
      },
      required: true
    },
    config: {
      type: Object,
      default: function _default() {
        return {};
      },
      required: false
    },
    interval: {
      type: String,
      default: '1h',
      required: false
    },
    hideLegend: {
      type: Boolean,
      required: false,
      default: false
    },
    minYAxis: {
      type: Number,
      required: false,
      default: null
    },
    maxYAxis: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      renderData: {
        labels: '',
        datasets: []
      },
      gradient_1: null,
      gradient_2: null,
      gradinet_3: null
    };
  },
  computed: {
    chartMap: function chartMap() {
      return {
        avg: {
          labelPrefix: this.$i18n_t('Common.chartOptions.average'),
          borderColor: '#41D927',
          // Green
          borderWidth: 1,
          backgroundColor: defaultChartConfig.drawBackground ? this.gradient_3 : 'transparent',
          spanGaps: this.config.spanGaps
        },
        min: {
          labelPrefix: this.$i18n_t('Common.chartOptions.min'),
          borderColor: '#05CBE1',
          // Blue
          borderWidth: 1,
          backgroundColor: defaultChartConfig.drawBackground ? this.gradient_2 : 'transparent',
          spanGaps: this.config.spanGaps
        },
        max: {
          labelPrefix: this.$i18n_t('Common.chartOptions.max'),
          borderColor: '#FC2525',
          // Red
          borderWidth: 1,
          backgroundColor: defaultChartConfig.drawBackground ? this.gradient_1 : 'transparent',
          spanGaps: this.config.spanGaps
        },
        latest: {
          labelPrefix: this.$i18n_t('Common.chartOptions.latest'),
          borderColor: '#EDD309',
          // Yellow
          borderWidth: 1,
          backgroundColor: defaultChartConfig.drawBackground ? this.gradient_4 : 'transparent',
          spanGaps: this.config.spanGaps
        },
        rawData: {
          labelPrefix: this.$i18n_t('Common.chartOptions.raw'),
          borderColor: '#EB34CC',
          // Pink
          borderWidth: 1,
          backgroundColor: defaultChartConfig.drawBackground ? this.gradient_5 : 'transparent',
          spanGaps: this.config.spanGaps
        }
      };
    }
  },
  watch: {
    chartData: {
      handler: function handler() {
        this.resetLineChartData();
        this.setLineChartData(this.chartData.data);
        this.renderChartGraph();
      },
      deep: true
    },
    config: {
      handler: function handler() {
        this.resetLineChartData();
        this.setLineChartData(this.chartData.data);
        this.renderChartGraph();
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.setGradientsColor();
    this.setLineChartData(this.chartData.data);
    this.renderChartGraph();
  },
  methods: {
    setLineChartData: function setLineChartData(data) {
      var _this = this;

      if (Object.keys(data || {}).length === 0) {
        // if not dataKeyForLabels exists chart data is empty and we will reset the chart
        this.resetLineChartData();
        return;
      } // all aggregated data have the same timestamp-series (except rawData),
      // so we can pick either one that is not rawData.


      var dataKeyForLabels = get(Object.keys(data).filter(function (k) {
        return k !== 'rawData';
      }), '[0]' // << IF this would return undefined, then ONLY rawData is selected
      // in which case it is alright to use it, as it does not interfere with anything else
      ) || 'rawData';

      if (!this.config.spanGaps) {
        // remove null values from chart data
        data = Object.keys(data).reduce(function (acc, key) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, data[key].filter(function (item) {
            return item.value !== null;
          })));
        }, {});
      }

      var timeLabels = data[dataKeyForLabels].map(function (item) {
        return item.time;
      });
      var timeSpanMs = this.getIntervalForUnit(); // offset the labels by 1 timeslot, to make it more "noob-friendly" understandable
      // https://digimondo.atlassian.net/browse/RD-6436

      if (timeLabels.length > 2 && dataKeyForLabels !== 'rawData') {
        timeLabels = timeLabels.map(function (t, i) {
          // do not touch the last timestamp, as that is the end of the interval
          // (Note: the items are reversed, to make sure that the latest values are displayed, so Index 0 === latest timestamp)
          if (i > 0) {
            var orgTimestamp = new Date(t);
            return new Date(orgTimestamp - timeSpanMs).toISOString();
          }

          return t;
        });
      }

      this.renderData = {
        // format time to human readable format for chart tick labels
        labels: timeLabels,
        // set datasets
        datasets: Object.keys(data).map(function (key) {
          return _objectSpread(_objectSpread({}, _this.chartMap[key]), {}, {
            // prefix label with corresponding labelPrefix
            label: "".concat(_this.chartMap[key].labelPrefix, " ").concat(_this.chartData.label),
            rawKey: key,
            timeSpanMs: timeSpanMs,
            // filter out time from data object
            data: data[key].map(function (item) {
              return item.value;
            })
          });
        })
      };
    },
    getIntervalForUnit: function getIntervalForUnit() {
      var unitMap = {
        m: 60 * 1000,
        h: 60 * 60 * 1000,
        d: 86400 * 1000,
        w: 7 * 86400 * 1000
      };
      var unit = unitMap[this.interval.slice(-1)];
      var amount = parseInt(this.interval.slice(0, this.interval.length - 1));
      return unit * amount;
    },
    getTimeFormatsForLocale: function getTimeFormatsForLocale() {
      var unitMap = {
        m: 'minute',
        h: 'hour',
        d: 'day',
        w: 'week'
      };
      var unit = unitMap[this.interval.slice(-1)];
      var locale = this.$store.state.app.language || 'en';
      return {
        unit: unit,
        locale: locale,
        displayFormats: {
          minute: locale === 'de' ? 'HH:mm' : 'h:mm a',
          hour: locale === 'de' ? 'HH:mm' : 'h:mm a',
          day: 'll',
          week: 'll'
        }
      };
    },
    renderChartGraph: function renderChartGraph() {
      var _this$getTimeFormatsF = this.getTimeFormatsForLocale(),
          locale = _this$getTimeFormatsF.locale,
          unit = _this$getTimeFormatsF.unit,
          displayFormats = _this$getTimeFormatsF.displayFormats;

      parseFloat(this.maxYAxis) || this.maxYAxis === 0 ? set(defaultChartConfig, 'scales.yAxes[0].ticks.max', parseFloat(this.maxYAxis)) : delete defaultChartConfig.scales.yAxes[0].ticks.max;
      parseFloat(this.minYAxis) || this.minYAxis === 0 ? set(defaultChartConfig, 'scales.yAxes[0].ticks.min', parseFloat(this.minYAxis)) : delete defaultChartConfig.scales.yAxes[0].ticks.min;
      set(defaultChartConfig, 'scales.xAxes[0].time.unit', unit);
      set(defaultChartConfig, 'scales.xAxes[0].time.displayFormats', displayFormats);
      defaultChartConfig.legend.display = this.hideLegend !== true; // set moment locale to current language

      moment.locale(locale);
      this.renderChart(this.renderData, merge({}, defaultChartConfig, this.config));
    },
    setGradientsColor: function setGradientsColor() {
      var colors = ['255, 0, 0', // Red
      '0, 231, 255', // Blue
      '65, 217, 39', // Green
      '237, 211, 9', // Yellow
      '235, 52, 204' // Pink
      ];

      for (var i = 0; i < colors.length; i++) {
        this["gradient_".concat(i + 1)] = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);
        this["gradient_".concat(i + 1)].addColorStop(0, "rgba(".concat(colors[i], ", 0.7)"));
        this["gradient_".concat(i + 1)].addColorStop(0.5, "rgba(".concat(colors[i], ", 0.4)"));
        this["gradient_".concat(i + 1)].addColorStop(1, "rgba(".concat(colors[i], ", 0)"));
      }
    },
    resetLineChartData: function resetLineChartData() {
      this.renderData = {
        labels: [],
        datasets: []
      };
    }
  }
};